import NavCertifiedTractorOn from '../../assets/svg/nav-certified_tractor-on.svg';
import NavCertifiedTractor from '../../assets/svg/nav-certified_tractor.svg';
import NavHomeOn from '../../assets/svg/nav-home-on.svg';
import NavHome from '../../assets/svg/nav-home.svg';
import NavMarketPriceOn from '../../assets/svg/nav-market-price-on.svg';
import NavMarketPrice from '../../assets/svg/nav-market-price.svg';
import NavOpenMarketOn from '../../assets/svg/nav-open-market-on.svg';
import NavOpenMarket from '../../assets/svg/nav-open-market.svg';
import NavPluvaAutoOn from '../../assets/svg/nav-pluva-auto-on.svg';
import NavPluvaAuto from '../../assets/svg/nav-pluva-auto.svg';
import { marketPricePageInfo, pageInfo } from '../pageInfo/pageInfo.constant';

export const bottomNavigatorButtonInfo = [
  {
    link: pageInfo.homePage.path,
    defaultIcon: NavHome,
    pressedIcon: NavHomeOn,
    isExternalLink: false,
    buttonTitle: '홈',
  },
  {
    link: `${pageInfo.productListPage.path}?category=all&status=all&brand=&sort=common`,
    defaultIcon: NavCertifiedTractor,
    pressedIcon: NavCertifiedTractorOn,
    isExternalLink: false,
    buttonTitle: '인증트랙터',
  },
  // TODO: 농번기에 메뉴에 표시할 필요가 생기면 주석처리 삭제
  // {
  //   link: PLUVA_SHOP_URL,
  //   defaultIcon: NavPluvaShop,
  //   pressedIcon: NavPluvaShop,
  //   isExternalLink: true,
  //   buttonTitle: '플루바샵',
  // },
  {
    link: pageInfo.openMarketListPage.path,
    defaultIcon: NavOpenMarket,
    pressedIcon: NavOpenMarketOn,
    isExternalLink: false,
    buttonTitle: '직거래',
  },
  // {
  //   link: newProductPageInfo.listPage.path,
  //   defaultIcon: NewProduct,
  //   pressedIcon: NewProductOn,
  //   isExternalLink: false,
  //   buttonTitle: '신품관',
  // },
  {
    link: marketPricePageInfo.listPage.path,
    defaultIcon: NavMarketPrice,
    pressedIcon: NavMarketPriceOn,
    isExternalLink: false,
    buttonTitle: '트랙터 시세',
  },
  {
    link: 'https://ion.pluva.kr/introduce',
    defaultIcon: NavPluvaAuto,
    pressedIcon: NavPluvaAutoOn,
    isExternalLink: false,
    buttonTitle: '플루바아이온',
  },
  // {
  //   link: pageInfo.cropTrendsListPage.path,
  //   defaultIcon: NavCropTrends,
  //   pressedIcon: NavCropTrendsOn,
  //   isExternalLink: false,
  //   buttonTitle: '농산물시세',
  // },
];
